//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import buttonMixin from './buttonMixin.js';

/**
 * KRouterLink creates a styled router-link
 */
export default {
  name: 'KRouterLink',
  mixins: [buttonMixin],
  props: {
    /**
     * vue-router link object
     */
    to: {
      required: true,
      type: Object,
    },
    /**
     * If provided, shows a KIcon in front of the text
     */
    icon: {
      type: String,
      required: false,
    },
    /**
     * If provided, shows a KIcon after the text
     */
    iconAfter: {
      type: String,
      required: false,
    },
    /**
     * Set a max width for content
     */
    maxWidth: {
      type: String,
      required: false,
      default: '100%',
    },
  },
  data() {
    return {
      hovering: false,
    };
  },
};

